var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import currentUserDetailsReducersMapObject from "@ane/exp-data/lib/userDetails/CurrentUserDetailsReducer";
import getWorkspaceReducersMapObject from "@ane/exp-ux/lib/components/GetWorkspace/GetWorkspace.ducks";
import reducer from "./reducers/AnalysisPlanReducer.js";
import { reducer as reducer$3 } from "./reducers/CurrentProgressionReducer.js";
import featureDataReducer from "./reducers/FeatureDataReducer.js";
import { FeatureRolloutLogPerformanceReducer } from "./reducers/FeatureRolloutLogPerformanceReducer.js";
import { r as reducer$2, b as reducer$4 } from "../FeatureDataActions-59549dc8.js";
import reducer$1 from "./reducers/OverrideReducer.js";
import UserAccessReducersMapObject from "@ane/exp-ux/lib/components/GetUserAccess/UserAccess.reducer";
import { reducer as reducer$5 } from "@ane/progression-scorecard-app-module/lib/module/views/AnalysisTemplate/ProgressionScorecard/ProgressionScorecard.ducks";
import RouteUpdateReducer from "@ane/core/lib/services/syncUrlAndStore/RouteUpdateReducer";
import LoadSubscribersReducersMapObject from "@ane/exp-ux/lib/components/Subscribers/LoadSubscribers.ducks";
import SetSubscribersReducersMapObject from "@ane/exp-ux/lib/components/Subscribers/SetSubscribers.ducks";
import { useSelector } from "react-redux";
import LoadSubscribersReducersMapObjectV2 from "@ane/exp-ux/lib/components/Subscribers/LoadSubscribersV2.ducks";
import SetSubscribersReducersMapObjectV2 from "@ane/exp-ux/lib/components/Subscribers/SetSubscribersV2.ducks";
import { authoringApi } from "@ane/exp-data/lib/redux/rtkquery";
const moduleReducer = __spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({
  analysisPlan: reducer,
  featureData: featureDataReducer,
  overrides: reducer$1,
  featureRolloutLogPerformance: FeatureRolloutLogPerformanceReducer,
  progressions: reducer$2,
  currentProgressionReducer: reducer$3,
  mds: reducer$4,
  progressionScorecard: reducer$5,
  [authoringApi.reducerPath]: authoringApi.reducer
}, RouteUpdateReducer), currentUserDetailsReducersMapObject), getWorkspaceReducersMapObject), UserAccessReducersMapObject), LoadSubscribersReducersMapObject), SetSubscribersReducersMapObject), LoadSubscribersReducersMapObjectV2), SetSubscribersReducersMapObjectV2);
const useModuleSelector = useSelector;
export {
  moduleReducer,
  useModuleSelector
};
//# sourceMappingURL=reducers.js.map
